import { ReactComponent as RescueWheel } from './svgs/rescue-wheel.svg';
import { Metadata } from '../../../types/metadata';

export const metadata: Metadata = {
  toolbarExternalLinks: [
    {
      Icon: RescueWheel,
      label: {
        en: 'Help center',
        he: 'מרכז התמיכה'
      },
      url: '/404',
      isPopup: true
    }
  ]
};
